<div class="row gallery-map">
    <div class="col-md-5">
        <div class="gallery-box" *ngIf="photo">
            <div class="gallery-img" #imageContainer>
            </div>
            <div class="gallery-info">
                <div class="form-inline">
                    <div class="form-group mb-2">
                        <label class="mr-3">Latitude</label>
                        <input type="text"
                               [appIsInvalid]="!photo.lat"
                               [submitted]="showValidation"
                               [(ngModel)]="photo.lat"
                               class="form-control mr-3">
                        <div class="invalid-feedback">
                            Photo Latitude is Required.
                        </div>
                    </div>
                    <div class="form-group mb-2">
                        <label class="mr-3">Longitude</label>
                        <input type="text"
                               [appIsInvalid]="!photo.lon"
                               [submitted]="showValidation"
                               [(ngModel)]="photo.lon"
                               class="form-control">
                        <div class="invalid-feedback">
                            Photo Longitude is Required.
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="canSetThumbnail">
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="setAsThumbnail.emit(photo)">
                        Set thumbnail
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-7">
        <app-map-picker [mapView]="mapLocation"
                        height="100%"
                        [zoomLevel]="12"
                        (locationChange)="setPhotoLocation($event)"
                        [location]="photo?.lat | latLonToPoint: photo?.lon"></app-map-picker>
    </div>
</div>
